import React, { Component } from 'react';
import Slider from "react-slick";


const postBlog = [
	{
		image: require('./../../images/testimonials/pic1.jpg'),
	},
	{
		image: require('./../../images/testimonials/pic2.jpg'),
	},
	{
		image: require('./../../images/testimonials/pic3.jpg'),
	},
	{
		image: require('./../../images/testimonials/pic2.jpg'),
	},
]


class owltestimonial extends Component {
	render() {
		var settings = {
			slidesToShow: 3,
			arrows: false,
			infinite: true,
			autoplay: true,
			responsive: [
				{
					breakpoint: 1200,
					settings: {
						slidesToShow: 3,
					}
				},
				{
					breakpoint: 991,
					settings: {
						slidesToShow: 2,
					}
				},
				{
					breakpoint: 576,
					settings: {
						slidesToShow: 1,
					}
				}
			]
		};
		return (

			<Slider className="blog-carousel-center owl-carousel owl-none " {...settings}>
				{postBlog.map((item, index) => {
					const testimonios = [
						{
							texto: "La asesoría laboral de UNIEMPLEO me ayudó a prepararme mejor para las entrevistas. Gracias a su orientación, conseguí el trabajo que buscaba.",
							nombre: "Carlos Rodríguez",
							posicion: "Egresado"
						},
						{
							texto: "Excelente plataforma. Los talleres sobre búsqueda de empleo fueron muy útiles y me dieron las herramientas necesarias para destacar en el mercado laboral.",
							nombre: "Ana Martínez",
							posicion: "Estudiante"
						},
						{
							texto: "Los asesores laborales son muy profesionales y están siempre dispuestos a ayudar. Recomiendo totalmente sus servicios.",
							nombre: "Juan Pérez",
							posicion: "Egresado"
						},
						{
							texto: "A través de UNIEMPLEO encontré mi trabajo ideal. La orientación que recibí fue fundamental para mi éxito profesional.",
							nombre: "Laura Sánchez",
							posicion: "Egresada"
						}
					];
					const testimonio = testimonios[index % testimonios.length];
					return (
						<div className="item p-3" key={index}>
							<div className="testimonial-5">
								<div className="testimonial-text">
									<p>{testimonio.texto}</p>
								</div>
								<div className="testimonial-detail clearfix">
									<div className="testimonial-pic radius shadow">
										<img src={item.image} width="100" height="100" alt="" />
									</div>
									<strong className="testimonial-name">{testimonio.nombre}</strong>
									<span className="testimonial-position">{testimonio.posicion}</span>
								</div>
							</div>
						</div>
					);
				})}

			</Slider>


		)

	}

}

export default owltestimonial;